<template>
  <div class="navbar-collapse collapse clearfix dropdown-margin">
    <ul class="navigation clearfix pad-r-en">
      <li
        v-for="menuItem in menuItems"
        :key="menuItem.id"
        class="dropdown for-mega"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <a
          class="service-h"
          :href="menuItem.href"
          :id="menuItem.id"
        >
          {{ $t(menuItem.label) }}
        </a>
        <div class="megamenu">
          <div class="row cont-pad">
            <div
              v-for="(column, index) in menuItem.columns"
              :key="`${menuItem.id}-${index}`"
              :class="column.class"
            >
              <h5 class="mega-title m-bold m-left">
                <a class="head-title" :href="column.titleHref">
                  {{ $t(column.title) }}
                </a>
              </h5>
              <ul class="m-col">
                <li v-for="link in column.links" :key="`${menuItem.id}-${link.href}`">
                  <a :href="link.href">
                    {{ $t(link.label) }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>

    <ul>
      <li class="contact-head-us">
        <a href="contact">Contact</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, getCurrentInstance } from "vue";
import { menuConfig } from "./menuConfig.js";

export default {
  name: "HeaderDesktop",
  setup() {
    const instance = getCurrentInstance();
    const menuItems = ref(menuConfig);

    const getLanguageBreakpoint = () => {
      // Check if current language is Spanish
      const isSpanish = instance?.appContext?.config?.globalProperties?.$i18n?.locale === 'es' ||
                       document.documentElement.lang === 'es' ||
                       localStorage.getItem('selectedLanguage') === 'es';
      return isSpanish ? 1024 : 1025;
    };

    const handleMouseEnter = (event) => {
      const breakpoint = getLanguageBreakpoint();
      
      if (window.innerWidth >= breakpoint) {
        // Close all other mega menus first
        const allMegamenus = document.querySelectorAll(".megamenu");
        allMegamenus.forEach((menu) => {
          if (menu !== event.currentTarget.querySelector(".megamenu")) {
            menu.style.display = "none";
            menu.style.opacity = "0";
          }
        });

        const megamenu = event.currentTarget.querySelector(".megamenu");
        if (megamenu) {
          // Reset styles first
          megamenu.style.display = "block";
          megamenu.style.opacity = "0";
          megamenu.style.transition = "none";
          
          // Calculate header height and navigation position dynamically
          const header = document.querySelector('.main-header');
          const navigation = document.querySelector('.navigation');
          let topPosition = 100; // fallback
         
          megamenu.style.top = `${topPosition}px`;
          
       
          // Smooth animation
          requestAnimationFrame(() => {
            megamenu.style.transition = "all 0.4s ease";
            megamenu.style.opacity = "1";
          });
        }
      }
    };

    const handleMouseLeave = (event) => {
      const breakpoint = getLanguageBreakpoint();
      
      if (window.innerWidth >= breakpoint) {
        const megamenu = event.currentTarget.querySelector(".megamenu");
        if (megamenu) {
          // Add a longer delay to prevent accidental closing
          setTimeout(() => {
            // Check if mouse is still over the menu item or mega menu
            const menuItem = event.currentTarget;
            const isHoveringMenuItem = menuItem && menuItem.matches(':hover');
            const isHoveringMegamenu = megamenu && megamenu.matches(':hover');
            
            if (!isHoveringMenuItem && !isHoveringMegamenu) {
              megamenu.style.transition = "all 0.4s ease";
              megamenu.style.opacity = "0";
              
              setTimeout(() => {
                if (megamenu && !megamenu.matches(':hover')) {
                  megamenu.style.display = "none";
                }
              }, 400);
            }
          }, 200);
        }
      }
    };

    const initializeMenus = () => {
      nextTick(() => {
        // Close menus when clicking outside
        document.addEventListener("click", (e) => {
          if (!e.target.closest(".navigation")) {
            const allMegamenus = document.querySelectorAll(".megamenu");
            allMegamenus.forEach((menu) => {
              menu.style.display = "none";
            });
          }
        });

        // Handle router link clicks
        document.querySelectorAll('.navigation a[href^="/"]').forEach(link => {
          link.addEventListener("click", () => {
            // Close all megamenus after navigation
            setTimeout(() => {
              const allMegamenus = document.querySelectorAll(".megamenu");
              allMegamenus.forEach((menu) => {
                menu.style.display = "none";
              });
            }, 100);
          });
        });
      });
    };

    onMounted(() => {
      initializeMenus();
    });

    return {
      menuItems,
      handleMouseEnter,
      handleMouseLeave,
    };
  },
};
</script>

<style scoped>
.megamenu {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  width: 100% !important;
  background: white;
  border: 1px solid #e0e0e0;
  z-index: 9999 !important;
  display: none;
  opacity: 0;
}

.dropdown.for-mega {
  position: relative;
}

.dropdown.for-mega:hover .megamenu {
  display: block !important;
}
</style>
